import { render, staticRenderFns } from "./CsoCoreIndicators.vue?vue&type=template&id=27e97f14&scoped=true"
import script from "./CsoCoreIndicators.vue?vue&type=script&lang=js"
export * from "./CsoCoreIndicators.vue?vue&type=script&lang=js"
import style0 from "./CsoCoreIndicators.vue?vue&type=style&index=0&id=27e97f14&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27e97f14",
  null
  
)

export default component.exports